import {useEffect, useState} from 'react';
import {FmlxButton, FmlxComboBox, FmlxDropdown, FmlxModal} from 'fmlx-common-ui';
import {useDropdown} from '../../../hooks/useDropdown';
import {MessageTypes} from '../../../const/dataEnum';
import {fetchEmployeesByDepartmentId} from '../../../stores/business/messageInboxBusiness';
import './MessageCreatorModal.scss';

const MessageCreateModal = ({open, onClose, onSend, userData}) => {
  const [selectedReceiver, setSelectedReceiver] = useState(null);
  const [message, setMessage] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [receiverList, setReceiverList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dropDownItems = [MessageTypes.KUDOS, MessageTypes.CRITICISM];
  const {items, selectedItem, setSelectedItem, handleDropdownChange, renderDropdownValue} = useDropdown(dropDownItems);

  const createMessagePayload = () => ({
    receiverId: selectedReceiver?.id,
    messageContent: message,
    isAnonymous: isAnonymous,
    messageTypeID: selectedItem,
  });

  const handleReceiverList = async () => {
    setIsLoading(true);
    try {
      const formattedList = await fetchEmployeesByDepartmentId(userData);
      setReceiverList(formattedList);
    } catch (err) {
      console.error('Error loading receiver list:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      handleReceiverList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleInitialSend = () => {
    const payload = createMessagePayload();
    onSend(payload);
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setSelectedReceiver(null);
    setMessage('');
    setIsAnonymous(false);
    setSelectedItem(-1);
  };

  const handleReceiverChange = (selectedItem) => {
    setSelectedReceiver(selectedItem);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  return (
    <FmlxModal
      open={open}
      title={'Create Message'}
      onCloseClick={onClose}
      customFooter={
        <div className="modal-footer">
          <FmlxButton label="Cancel" type="primary" variant="outline" onClick={onClose}/>
          <FmlxButton label="Send" type="secondary" variant="contain" onClick={handleInitialSend}/>
        </div>
      }
    >
      <div className="modal-content">
        <p>
          Give comments, notes, or appreciation for colleagues. This message will be curated by the Division Manager and
          will be decided if it will be published or not.
        </p>
        <div className="form-group">
          <label>Receiver</label>
          {isLoading ? (
            <p>Loading receivers...</p>
          ) : (
            <FmlxComboBox items={receiverList} selectedItem={selectedReceiver} onChange={handleReceiverChange}/>
          )}
        </div>
        <div className="form-group">
          <label>Message Type</label>
          <FmlxDropdown
            items={items}
            selectedItem={selectedItem}
            onChange={handleDropdownChange}
            renderDropdownValue={renderDropdownValue}
          />
        </div>
        <div className="form-group">
          <label>Message</label>
          <textarea value={message} onChange={handleMessageChange}/>
        </div>
        <div className="form-group">
          {/* <label>
            <input type="checkbox" checked={isAnonymous} onChange={() => setIsAnonymous(!isAnonymous)} />
            Send as Anonymous
          </label> */}
        </div>
      </div>
    </FmlxModal>
  );
};

export default MessageCreateModal;
